import React, { Component, Ref } from 'react'
import { Container, withPixiApp } from "@inlet/react-pixi";
import UIManager from "../../core/components/ui/UiBuilder";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { isMobile } from "react-device-detect";
import { Ilanguage } from "../../core/interface/Icommon";
import { _ReactPixi } from "@inlet/react-pixi";
import { alllanguage } from "../../data/lang/index"
import { CURRENCY } from "../../core/utills";
import winDropConfigurationContext from "./configuration/withwindropconfiguration";
//import GridcontainerAL from "../gridcontainerAL/gridContainerAL";
import { Tween } from "../../core/components/effect/tween";
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { actions as winDropActions } from '../../gamereducer/winDropReducer'
import { actions as trailActions } from '../../gamereducer/trailReducer'


interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;
}

interface IStateToProps {

}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class WinDropComponent extends Component<IProps, IState> {
    private app: PIXI.Application;
    protected winDropContainer: _ReactPixi.IContainer | Ref<any>;
    protected displayUI: any;
    protected ui_mode: string;
    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.winDropContainer = React.createRef();
        this.state = {
            uiElements: [],
            lang: "en",
            freshRender: true,
        }
        if (isMobile) {
            this.ui_mode = "mobile"
        } else {
            this.ui_mode = "desktop"
        }
        this.displayUI = this.props.data.COMPONENTS[0].child.filter(this.checkUiMode.bind(this));

    }

    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    bindUI() {

        this.setState((prevState) => {
            return {
                ...prevState,
                freshRender: false
            }
        });


    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        this.layoutChange(this.props.layoutMode)
    }

    componentDidMount() {
        this.bindUI()
    }

    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any, j: number) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name)
            }
        });
    }

    handleEvent = (e: any) => {

    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        // console.log("-- yahoo windrop SHD --");
        return true
    }
    shouldComponentUpdate_(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        //blastStart
        if (nextProps.winDropCount !== this.props.winDropCount
            || nextProps.startWinDrop !== this.props.startWinDrop) {

            if (nextProps.startWinDrop && nextProps.startWinDrop !== this.props.startWinDrop) {

                this.startWinDrops(this.props.count)
                this.props.startTrail();
            }
            if (nextProps.winDropCount !== this.props.winDropCount && this.props.name == "drop_component_" + nextProps.winDropCount) {
                const dropBox = UIManager.getRef("drop_component_" + nextProps.winDropCount);
                if (nextProps.winDropCount > 7) {

                    for (let i = 0; i < this.props.windroplistPass.length; i++) {
                        new Tween(
                            [this.props.windroplistPass[i]],
                            {

                                ['y']: { start: this.props.windroplistPass[i].y, end: this.props.windroplistPass[i].y + 60 }
                            },
                            0.4,
                            "easeOutBounce",
                            false, null, null, null, null, false, onchange, () => {

                            }
                        );
                    }

                    dropBox && (this.displayUI[1].image = "iconWP_" + nextProps.winDropList[nextProps.winDropCount].symbolId)
                    dropBox && (this.displayUI[2].text = "x" + nextProps.winDropList[nextProps.winDropCount].multiplier)
                    dropBox && (this.displayUI[3].text = "$" + nextProps.winDropList[nextProps.winDropCount].wonAmount)
                    dropBox && (dropBox.visible = true);
                    dropBox && this.addDropTween(nextProps, dropBox, 60, 0.4, "easeOutBounce");


                } else {
                    dropBox && (this.displayUI[1].image = "iconWP_" + nextProps.winDropList[nextProps.winDropCount].symbolId)
                    dropBox && (this.displayUI[2].text = "x" + nextProps.winDropList[nextProps.winDropCount].multiplier)
                    dropBox && (this.displayUI[3].text = "$" + nextProps.winDropList[nextProps.winDropCount].wonAmount)
                    dropBox && (dropBox.visible = true);
                    dropBox && this.addDropTween(nextProps, dropBox, 420 - nextProps.winDropCount * 60, 0.4, "easeOutBounce");

                }
                return true

            }

            return false
        }
        return true;
    }

    startWinDrops(count: any) {
        const dropBox = UIManager.getRef("drop_component_" + this.props.count)
        if (dropBox.name == "drop_component_0") {
            this.props.setWinDropCount();
        }
    }

    addDropTween(updatedProps: any, dropCont: any, yPos: number, duration: number, easing: string) {
        const droppingTween = new Tween(
            [dropCont],
            {

                ['y']: { start: dropCont['y'], end: yPos }
            },
            duration || 0.001,
            easing,
            false, null, null, null, null, false, onchange, () => {
                if (updatedProps.winDropCount < updatedProps.winDropList.length) {
                    this.props.windroplistPass.push(dropCont)
                    this.props.endTrail()
                    updatedProps.setWinDropCount();
                }
            }
        );
    }
    correctCurrencyCodeXAF(amount: string) {
        if ((window as any).GAME_INFO.currency == "XAF") {
            return amount.replace('F', 'FCFA');
        }
        if ((window as any).GAME_INFO.currency == "XOF") {
            return amount.replace('F', 'XOF');
        }
        return amount;
    }

    render() {
        this.displayUI[1].image = "iconWP_" + this.props.winDropList[this.props.count].symbolId;
        this.displayUI[2].text = "x" + this.props.winDropList[this.props.count].multiplier;
        this.displayUI[3].text = this.props.displayInCoins ? this.props.winDropList[this.props.count].wonAmount : this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(this.props.winDropList[this.props.count].wonAmount / 10 * this.props.coinList[this.props.currentBetIndex], true, true, true, true));
        return (
            <UIManager key={`winDropContainer-${Math.random()}` + this.props.count} props={this.props} id={`winDropContainer-${Math.random()}` + this.props.count} name={`winDropContainer-${Math.random()}` + this.props.count} x={this.props.x} y={this.props.y} type={"Container"} ref={i => this.winDropContainer = i} justCreated={true} >
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-winDrop-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} ClickHandler={this.handleEvent.bind(this)} />)
                }
            </UIManager>
        );
    }
}

export default withPixiApp(connect(
    (state: Pick<IStore, 'betPopUpState' | 'basegameState' | 'winDropState' | 'betPanelState' | 'applicationState' | 'behaviourState'>): IStateToProps =>
    ({
        currentBetIndex: state.betPanelState.selectedCoin,
        betList: state.basegameState.betList,
        coinList: state.betPanelState.coinList,
        displayInCoins: state.behaviourState.displayInCoins,
        // winDropCount: state.winDropState.winDropCount,
        // winDropList: state.winDropState.winDropList,
        // startWinDrop: state.winDropState.startWinDrop,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        // setWinDropCount: (): any => dispatch(winDropActions.setWinDropCount()),
        // startTrail: (): any => dispatch(trailActions.startTrail()),
        // endTrail: (): any => dispatch(trailActions.endTrail()),
        // setApplicationLayoutObject: (layoutobjectlist: string): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
    }))(winDropConfigurationContext(WinDropComponent)));